//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Form, Header, Button, ButtonStyle, Modal } from '@cmp/common';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { GigyaStatus, GigyaSessionDuration } from '@helpers/constants/gigya';
import { withTranslation } from 'react-i18next';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import { handleGtmEvent } from '@helpers/gtm';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
    };
  }

  componentDidMount() {
    let that = this;
    const {
      storeConfig: { language },
    } = this.context;

    gigya.accounts.showScreenSet({
      screenSet: 'Hvd-RegistrationLogin',
      containerID: 'forgot-password-container',
      lang: language || 'en',
      startScreen: 'gigya-forgot-password-screen',
      sessionExpiration: GigyaSessionDuration,
      onAfterSubmit: ({ response }) => {
        that.setState({ submitted: response.status !== GigyaStatus.FAIL });
      },
      onAfterScreenLoad: (e) => {
        document
          .getElementById('gigya-forgot-password-screen')
          .querySelectorAll('.gigya-input-text,.gigya-input-password')
          .forEach((nodeInput) => {
            nodeInput.addEventListener('keyup', (event) => {
              window.interactiveLabel(event);
            });
          });
      },
    });
  }

  recoverForm() {
    const { t } = this.props;

    handleGtmEvent('login', {
      eventParameters: {
        omnibus: true,
        method: 'Gigya',
        action: 'forgot password start',
        user_type: 'vet',
      },
    });

    return (
      <Form
        className={styles.RecoveryForm}
        title={t('login_RecoverYourPassword')}
        subtitle={t('login_RecoverYourPasswordSubtitle')}
        id="forgot-password-container"
        additionalComponent={
          <Link to="/" className={styles.GoBack}>
            {t('login_GoBackToLogin')}
          </Link>
        }
      />
    );
  }
  submittedForm() {
    const { t } = this.props;

    handleGtmEvent('login', {
      eventParameters: {
        omnibus: true,
        method: 'Gigya',
        action: 'forgot password success',
        user_type: 'vet',
      },
    });

    return (
      <Form
        className={styles.RecoverySentForm}
        title={t('login_PasswordRecoveryEmailSent')}
        subtitle={t('login_PasswordRecoveryEmailSentSubtitle')}
        submit={t('login_BackToLogin')}
        submitTo="/"
      />
    );
  }

  render() {
    const { className, t, history, location } = this.props;
    const { submitted } = this.state;

    const componentClasses = classNames(styles.ForgotPassword, {
      [className]: className,
    });

    return (
      <Modal.Base className={componentClasses} onClose={() => history.goBack()}>
        <Helmet>
          <title>{t('login_ForgotYourPassword')}</title>
        </Helmet>

        <Header className={styles.ForgotPasswordPageHeader} />
        {submitted ? this.submittedForm() : this.recoverForm()}
      </Modal.Base>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(ForgotPassword);
ForgotPassword.contextType = StoreConfigContext;
